import { render, staticRenderFns } from "./Fawry.vue?vue&type=template&id=7b2141ff&"
import script from "./Fawry.vue?vue&type=script&lang=js&"
export * from "./Fawry.vue?vue&type=script&lang=js&"
import style0 from "./Fawry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports